/* eslint-disable react/prop-types */
import { createContext, useState, useEffect } from "react";

export const MartContext = createContext(null);

const MartContextProvider = ({ children }) => {
  // Initialize cart state with data from localStorage, if available
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });
  const [recentOrder, setRecentOrder] = useState(null);

  // Sync cart state with localStorage whenever cart changes
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  // Add item to cart, ensuring unique items are added and quantities updated
  const addToCart = (newItem) => {
    const itemWithPharmacistId = {
      ...newItem,
      pharmacistId: newItem.pharmacistId,
    };

    setCart((prevCart) => {
      const existingItem = prevCart.find(
        (item) => item._id === itemWithPharmacistId._id
      );

      if (existingItem) {
        // Increase quantity of the existing item
        return prevCart.map((item) =>
          item._id === itemWithPharmacistId._id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        // Add new item to the cart
        return [...prevCart, { ...itemWithPharmacistId, quantity: 1 }];
      }
    });
  };

  // Remove item from cart
  const removeFromCart = (itemId) => {
    setCart((prevCart) => prevCart.filter((item) => item._id !== itemId));
  };

  // Clear the entire cart
  const clearCart = () => {
    setCart([]);
  };

  // Increase quantity of a specific item
  const increaseQuantity = (itemId) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item._id === itemId ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  // Decrease quantity of a specific item, and remove it if quantity drops to zero
  const decreaseQuantity = (itemId) => {
    setCart(
      (prevCart) =>
        prevCart
          .map((item) =>
            item._id === itemId && item.quantity > 1
              ? { ...item, quantity: item.quantity - 1 }
              : item
          )
          .filter((item) => item.quantity > 0) // Remove items with quantity 0
    );
  };

  // Handle order placement
  const placeOrder = (orderData) => {
    setRecentOrder(orderData);
    clearCart(); // Optionally clear the cart after placing the order
  };

  return (
    <MartContext.Provider
      value={{
        cart,
        setCart,
        addToCart,
        removeFromCart,
        clearCart,
        increaseQuantity,
        decreaseQuantity,
        placeOrder,
        recentOrder,
      }}
    >
      {children}
    </MartContext.Provider>
  );
};

export default MartContextProvider;
